import { MOCK_RESOURCE_LIBRARY_DATA_FLAG } from 'utils/highschoolHelpers'
import {
  EXPORT_BUTTON_UPDATE_FLAG,
  HS_SITE_REPORTS_LESSON_PAGE_FLAG,
  PUBLISHED_CONTENT_FLAG,
} from 'utils/featureFlags'
import { GOALS_MODAL_EXPERIMENT } from './abTestFlags'

// Add in the flag name of flags as strings.
// REQUIRED for any flags to work. Subscribe here for the app to listen to any of these flags and get values
// For example:
// ['feature_learn-2790_react-poc_01-2020']
export default [
  MOCK_RESOURCE_LIBRARY_DATA_FLAG,
  'feature_learn-18453-hs-student-extension-activities',
  'feature_LEARN-20164-k5-site-selection',
  'feature_LEARN-24549_Tier_2_Reporting',
  'refactor_LEARN-18413-pages-component-program-flex',
  'feature_LEARN-28194-recent-activities',
  'feature_LEARN-28473-learn-k12-core-curriculum-service-integration',
  'feature_learn-individual-resource-print-controls',
  'BTS-2026_publishWorkflows',
  'feature_LEARN-26293-experience-player-in-learn',
  'BTS-2026_playbookDateTest',
  'LEARN-BTS-Playbook-2026',
  PUBLISHED_CONTENT_FLAG,
  'feature_LEARN-25816-dwb-reporting',
  'feature_LEARN-28095-class-sharing',
  'feature_LEARN-28848-add-confetti',
  EXPORT_BUTTON_UPDATE_FLAG,
  HS_SITE_REPORTS_LESSON_PAGE_FLAG,
  GOALS_MODAL_EXPERIMENT.flagName,
]
